import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { APP_NAME } from 'app-config'

import { getUserStatusAction } from 'root-redux/actions/user'
import { selectUUID } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

export const useSetUserStatus = () => {
  const dispatch: TAppDispatch = useDispatch()
  const uuid = useSelector(selectUUID)

  useEffect(() => {
    if (uuid && APP_NAME) {
      dispatch(getUserStatusAction(uuid))
    }
  }, [dispatch, uuid])
}
